<template>

	<div class="portlet box purple">

		<div class="portlet-title">

			<div class="caption">
				<i class="fa fa-pencil" aria-hidden="true"></i>
				<span v-translate>Observações</span>
			</div>

		</div>

		<div class="portlet-body clearfix">
			<textarea id="eventual-medication-notes" name="eventual-medication-notes" :value="observation" class="form-control" rows="6" maxlength="1000" @change="putAgendaObservation"></textarea>
			<!-- <textarea-counter :size="notes.length" :limit="1000" :class="'pull-right'" /> -->
		</div>

	</div>

</template>

<script>

	import StudentObservation from './';
	export default StudentObservation;

</script>



// WEBPACK FOOTER //
// observation.vue?3fc28d96